import * as ActionTypes from '../actions/kitchenHistoryPlayerAction';

const initialState = {
  startDate: null,
  endDate: null,
  pollingStartDate: null,
  pollingEndDate: null,
  timeInterval: null,
  jumpToEventListenerInitialized: false,
};

const kitchenHistoryPlayerReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.CHANGE_KHP_VALUE:
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };
      
    case ActionTypes.CHANGE_KHP_SEVERAL_VALUES: {
      return {
        ...state,
        ...action.payload,
      };
    }

    case ActionTypes.RESET_KHP_STORE: {
      return {
        ...state,
        ...initialState,
      };
    }

    default: {
      return state;
    }
  }
};

export default kitchenHistoryPlayerReducer;
